// Buffer playback stays inside the game, without an HTML media player on phones.
export class MobileGameMusic {
  private context?: AudioContext;
  private gain?: GainNode;
  private source?: AudioBufferSourceNode;
  private playlist: Record<string, string[]> = {};
  private buffers = new Map<string, AudioBuffer>();
  private scene = '-1';
  private muted = true;
  private active = false;
  private volume = 0.1;
  private version = 0;

  setPlaylist(playlist: Record<string, string[]>) {
    this.playlist = playlist;
    if (this.active && !this.muted) void this.start();
  }
  play(scene: number) {
    const next = String(scene);
    if (this.active && this.scene === next) return;
    this.scene = next;
    this.active = true;
    this.stop();
    if (!this.muted) void this.start();
  }
  setMuted(muted: boolean) {
    this.muted = muted;
    if (muted) this.stop();
    else if (this.active) void this.start();
  }
  setVolume(volume: number) {
    this.volume = Math.max(0, Math.min(1, volume / 100));
    if (this.gain) this.gain.gain.value = this.volume;
  }
  pause() { this.active = false; this.stop(); }
  dispose() { this.pause(); if (this.context) void this.context.close().catch(() => {}); this.buffers.clear(); }
  private stop() {
    this.version++;
    if (this.source) { this.source.onended = null; this.source.stop(); this.source.disconnect(); this.source = undefined; }
  }
  private async start() {
    this.stop();
    const version = this.version;
    try {
      const Audio = window.AudioContext || (window as any).webkitAudioContext;
      if (!Audio) return;
      if (!this.context) {
        this.context = new Audio();
        this.gain = this.context!.createGain();
        this.gain.connect(this.context!.destination);
      }
      const context = this.context!;
      // Called directly by the game's sound toggle, so mobile can unlock audio.
      await context.resume();
      const songs = this.playlist[this.scene] || this.playlist['-1'];
      if (!songs?.length) return;
      const song = songs[Math.floor(Math.random() * songs.length)];
      let buffer = this.buffers.get(song);
      if (!buffer) {
        const response = await fetch(`${process.env.REACT_APP_CDN_PATH || 'assets/'}audio/${song}`);
        if (!response.ok) return;
        buffer = await context.decodeAudioData(await response.arrayBuffer());
        this.buffers.set(song, buffer);
      }
      if (version !== this.version || this.muted || !this.active) return;
      this.gain!.gain.value = this.volume;
      const source = context.createBufferSource();
      source.buffer = buffer;
      source.connect(this.gain!);
      source.onended = () => { if (!this.muted && this.active) void this.start(); };
      this.source = source;
      source.start();
    } catch { /* Audio/network restrictions must not interrupt gameplay. */ }
  }
}
